module.exports = __webpack_public_path__ + "static/media/942688_561742220532237_1123917956_n.2347ca6b.jpg";